import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './AgentDetailsForm.css';
import axios from 'axios';
import { TextField } from '@mui/material';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import SelectedProductCarousel from '../products_carousel/SelectedProductCarousel';
import { useNavigate } from 'react-router-dom';

function AgentDetailsForm() {
    const [formDetails, setFormDetails] = useState({});
    const [inputValues, setInputValues] = useState({});
    const [errors, setErrors] = useState({});
    const [error, setError] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [selectedError, setSelectedError] = useState('');
    const [getProductSku,setGetProductSku] = useState('');
    // const [isExistedDetails, setIsExistedDetails] = useState(false);

    const { agentId, id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`https://ad-prod.smytten.com/offline/misscalllog/${id}`)
            .then((res) => {
                let obj = res.data

                console.log(obj,"obj--obj---")
                obj.fields = obj.fields.map(e => {
                    return {
                        ...e,
                        value: e.value ? e.value : ''
                    }
                })
                setFormDetails(obj);
            })
            .catch((error) => {
                console.error(error);
            });
    }, [id]);

    useEffect(()=> {
        axios.get(`https://ad-prod.smytten.com/offline/misscalllog/${id}?agent_id=${agentId}&status=CLOSED`)
        .then((res) => {
            // res.data.selected_product
            setGetProductSku(res.data?.selected_product);

            
            console.log(res?.data,"get-sku-product-data--");

        })
    },[id])


    const handleInputChange = (e, index) => {
        // const { name, value } = e.target;

        let obj = formDetails?.fields[index]

        obj['value'] = e.target.value

        let copy = formDetails?.fields
        copy[index] = obj

        setFormDetails({ ...formDetails, fields: [...copy] })

        if (errors[obj.name]) {
            const validationError = validateField(obj);
            if (!validationError) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [obj.name]: '',
                }));
            }
        }
    };

    const validateField = (field) => {
        const { name, value } = field;
        if (name === 'name') {
            if (!value) {
                return 'Name is required';
            } else if (value.length <= 3) {
                return 'Name should have a length of at least 3 characters';
            } else if (!isNaN(value)) {
                return 'Name should not include numbers';
            }
        }
        // if (name === 'phone' && (value === '' || isNaN(value)) || value.toString().length>10) {
        //     return 'Invalid phone number';
        // }

        console.log(value, "new--values---")
        if (name === 'phone') {
            if (!value) {
                return 'Phone number is required';
            } else if (value.length !== 10) {
                return 'Invalid phone number. It should be a 10-digit number.';
            }
        }

        if (name === 'pincode' && (value === '' || isNaN(value))) {
            return 'Invalid pincode';
        } if (name === 'city' && !value) {
            return 'City is required';
        } if (name === 'gender' && !value) {
            return 'Gender is required';
        }
        return '';
    };

    const validateForm = () => {
        const validationErrors = {};
        formDetails.fields.forEach((element) => {
            const validationError = validateField(element);
            if (validationError) {
                validationErrors[element.name] = validationError;
            }
        });
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    console.log(formDetails.status, "status-value...")

    function handleSubmit(e) {
        e.preventDefault();

        const isValid = validateForm();

        if (isValid) {
            const result = formDetails?.fields?.map((element) => {
                return {
                    id: element.id,
                    value: element.value,
                };
            });

            if (!selectedProduct) {
                setSelectedError('please select the product')
            } else {
                setSelectedError('');
                axios.put(`https://ad-prod.smytten.com/offline/misscalllog/${id}?agent_id=${agentId}&status=CLOSED`, {
                    status: "CLOSED",
                    fields: result,
                    selected_product: selectedProduct
                }).then((res) => {
                    console.log(res.data, "updated-form...")
                }).catch((err) => {
                    console.log(err, "error-updating-values...")
                });
                navigate(`/offline-frontend/leadlist/${agentId}`)
            }
        }
    }

    return (
        <div className='main-agent-details-container'>
            <div>
                <h2 className='details-text-agent'>Details</h2>
                <div className='campaign-name-container'>
                    <p className='campaign-name'>Campaign Name : {formDetails.campaign}</p>
                </div>
            </div>

            <p className='fill-details-container'>Fill the details</p>
            <div className='wrapper-container-details'>

                <form
                    className='main-form-container'
                >
                    {
                        formDetails?.fields?.map((element, index) => (
                            <div className='input-group-details' key={element.id}>
                                <label>{element.display}</label>
                                {element.name === 'gender' ? (
                                    <div className='gender-container'>
                                        <FormControl style={{ fontSize: '16px' }}>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue="female"
                                                name="radio-buttons-group"
                                                style={{ display: 'flex', flexDirection: 'row', fontSize: '16px' }}
                                            >
                                                <FormControlLabel value="female"
                                                    control={<Radio />} label="Female"
                                                    id="female"
                                                    name="gender"

                                                    checked={element.value === 'female'}
                                                    onChange={(e) => handleInputChange(e, index)}
                                                    tyle={{ fontSize: '16px' }} isExistedDetails
                                                />
                                                <FormControlLabel value="male" control={<Radio />}
                                                    label="Male"
                                                    id="male"
                                                    name="gender"
                                                    checked={element.value === 'male'}
                                                    onChange={(e) => handleInputChange(e, index)}
                                                    tyle={{ fontSize: '16px' }}
                                                />

                                            </RadioGroup>
                                        </FormControl>

                                    </div>
                                ) : (
                                    <TextField
                                        type={element.name === 'phone' || element.name === 'pincode' ? 'number' : 'text'}
                                        variant="outlined"
                                        name={element.name}
                                        value={element.value}
                                        onChange={(e) => handleInputChange(e, index)}
                                        size='small'
                                    />
                                )}

                                {errors[element.name] && <span className='error-details-agent'>{errors[element.name]}</span>}
                                {/* {errors[element.name] && <span className='error-details-agent'>{errors[element.name]}</span>} */}
                                {/* {error && element.value === '' && <span className='error-details-agent'>Invalid value</span>} */}
                            </div>
                        ))
                    }

                    <div className='carousel-product'>
                        <SelectedProductCarousel
                            products={formDetails?.products}
                            selectedProduct={selectedProduct}
                            setSelectedProduct={setSelectedProduct}
                            getProductSku={getProductSku}
                            formDetails={formDetails}
                        />
                        {selectedError && <span className='error-details-agent'>{selectedError}</span>}

                    </div>

                    <div className='submit-container-details'
                        onClick={(e) => handleSubmit(e)}
                    >
                        <Button
                            variant='contained'
                            style={{ backgroundColor: '#20225D', fontWeight: 'bold', width: '100%' }}
                        >
                            Submit
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default AgentDetailsForm;
